export const upsertOne = (oldData, updated) => {
    if (!Array.isArray(oldData)) return updated;
    const idx = oldData.findIndex((k) => k?.keyId === updated?.keyId);
    if (idx === -1) return [updated, ...oldData];
    const copy = oldData.slice();
    copy[idx] = updated;
    return copy;
};

export const overrideCache = (oldData, updated) => {
    return updated;
};

export const onSuccessfulResponse = (queryClient, cacheKey, transformer, response) => {
    if (!cacheKey || !response || !queryClient || !transformer) return;
    queryClient.setQueryData(cacheKey, (old) => transformer(old, response));
};
